import { useEffect, useLayoutEffect, useRef, useState } from "react";
import { useFilter } from "../../context/FilterContext";


const SelectInputDynamic = ({ label1,id1,options1=[],label2,id2,defaultOption2=[],options2={},onValueChange,manualInput }:any) => {
    const [value1, setValue1] = useState<any>(null);
    const [value2, setValue2] = useState<any>(null);

    const { filterParams, setFilterParams } = useFilter();
    
    useLayoutEffect(() => {
        if(!label1||!id1||!options1){
            console.warn("[SelectInputDynamic] missing first input config,",label1,id1,options1)
        }
        if(!label2||!id2||!defaultOption2 ||! options2){
            console.warn("[SelectInputDynamic] missing second input config,",label2,id2,defaultOption2,options2)
        }
    }, []);

    useEffect(() => {
        onValueChange(id1,value1);
        //clear second id value
        setValue2(null);
    }, [value1]);

    useEffect(() => {
        onValueChange(id2,value2)
    }, [value2]);

    const handleValue1Change = (e:any)=>{
        setValue1(e.target.value);
    }

    const handleValue2Change = (e:any)=>{
        setValue2(e.target.value);
    }


   
    const selectRef2 = useRef(null);
    const setSelectValue2 = (value) => {
        if (selectRef2.current) {
            selectRef2.current.value = value;
        }
    };

    //manual update value2
    useEffect(() => {
        if(manualInput[id2]){
            setSelectValue2(manualInput[id2]);
        }
    }, [manualInput]);

    return (
        <>
            <div className="col-xxxxl-12 col-xl-12 col-lg-12 col-md-12 col-12">
                {' '}
                <div className="input-container ">
                    <div className="label"> {label1} </div>
                    <select className="custom" defaultValue={''}
                        onChange={(e) => handleValue1Change(e)}
                    >
                        {
                            options1.map((option:any,i:any) => {
                                return (
                                    <option key={i} value={option.value}>
                                        {option.label}
                                    </option>
                                );
                            })
                        }
                    
                    </select>
                </div>
            </div>
            <div className="col-xxxxl-12 col-xl-12 col-lg-12 col-md-12 col-12">
                {' '}
                <div className="input-container ">
                    <div className="label"> {label2} </div>
                    <select className="custom" defaultValue={''}
                        onChange={(e) => handleValue2Change(e)}
                        ref={selectRef2}
                    >
                        {
                            !options2[value1]  && defaultOption2.map((option:any,i:any) => {
                                return (
                                    <option key={i} value={option.value}>
                                        {option.label}
                                    </option>
                                );
                            })
                        }
                    
                        {
                            (value1 && options2[value1]) && options2[value1].map((option:any,i:any) => {
                                return (
                                    <option key={i} value={option.value}>
                                        {option.label}
                                    </option>
                                );
                            })
                        }
                    
                    </select>
                </div>
            </div>
        </>
    );
}

export default SelectInputDynamic;